export default "__VITE_ASSET__BlGCfAaB__"